var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2289_7286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.5H12.5V5C12.5 3.6625 11.9792 2.40833 11.0375 1.4625C10.0917 0.516667 8.8375 0 7.5 0C6.1625 0 4.90833 0.520833 3.9625 1.4625C3.01667 2.40833 2.5 3.6625 2.5 5V7.5H1.875C0.841667 7.5 0 8.34167 0 9.375V18.125C0 19.1583 0.841667 20 1.875 20H13.125C14.1583 20 15 19.1583 15 18.125V9.375C15 8.34167 14.1583 7.5 13.125 7.5ZM3.75 5C3.75 4 4.14167 3.05833 4.85 2.35C5.55833 1.64167 6.5 1.25 7.5 1.25C8.5 1.25 9.44167 1.64167 10.15 2.35C10.8583 3.05833 11.25 4 11.25 5V7.5H3.75V5ZM13.75 18.125C13.75 18.4708 13.4708 18.75 13.125 18.75H1.875C1.52917 18.75 1.25 18.4708 1.25 18.125V9.375C1.25 9.02917 1.52917 8.75 1.875 8.75H13.125C13.4708 8.75 13.75 9.02917 13.75 9.375V18.125Z",
    fill: "#194142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.375C8.01777 14.375 8.4375 13.9553 8.4375 13.4375C8.4375 12.9197 8.01777 12.5 7.5 12.5C6.98223 12.5 6.5625 12.9197 6.5625 13.4375C6.5625 13.9553 6.98223 14.375 7.5 14.375Z",
    fill: "#194142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2289_7286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.1a6610e7c7fd5ee02232be5706050a3c.svg";
export { ForwardRef as ReactComponent };